module.exports = __webpack_public_path__ + "img/284448885.8c1a08f6.jpg";